// anchorPlugin.js
export default function anchorPlugin(md) {
  function anchorInline(state, silent) {
    const pos = state.pos;
    const src = state.src;

    let end;
    let id = null;

    // Variante 1: [anker=XY]
    if (src.charCodeAt(pos) === 0x5B /* [ */) {
      end = src.indexOf("]", pos);
      if (end === -1) return false;

      const inside = src.slice(pos + 1, end);
      const match = inside.match(/^anker=([A-Za-z0-9_-]+)$/);

      if (!match) return false;
      id = match[1];
    }

    // Variante 2: {#XY}
    else if (src.charCodeAt(pos) === 0x7B /* { */) {
      end = src.indexOf("}", pos);
      if (end === -1) return false;

      const inside = src.slice(pos + 1, end);
      const match = inside.match(/^#([A-Za-z0-9_-]+)$/);

      if (!match) return false;
      id = match[1];
    }

    else {
      return false;
    }

    if (silent) return true;

    const token = state.push("anker", "", 0);
    token.attrs = [["id", id]];

    state.pos = end + 1;
    return true;
  }

  md.inline.ruler.before("emphasis", "anker_inline", anchorInline);
}